import { Definition, Property } from "../../../data/Definition";
import { DwQuery } from "../../../data/Query";
import { fetchData } from "../utils/dwHelpers";
import { GeoJsonLayer, ColumnLayer } from "@deck.gl/layers";
import { MapLayer, IDeckGlLayer, IFieldFilter, ITimeFilter } from "./MapLayer";
import { Field } from "../types/types";
import { dcRound } from "../utils/misc";

export type DWPropertyQueryConfig = {
    title: string;
    name: string;
    property: string;
    statistic?: string;
    summerize: "avg" | "min" | "max";
    scale?: {
        min: number;
        max: number;
    };
    geojson?: boolean;
};

export type DWPropertyScaleDesc = {
    name: string;
    min: number;
    max: number;
};

export type DWQueryConfig = {
    title: string;
    description?: string;
    visible: boolean;
    definitionName: string[];
    type: "point" | "polygon";
    properties: DWPropertyQueryConfig[];
    categoryColors?: any;
    layerType: "geojson" | "column";
    layerOptions?: any;
    colorRamp: 'Portland' | 'BlRdYlGrBu' | 'Earth' | 'RdBu',
    transform?: (scalers: DWPropertyScaleDesc[], colorRamp: string, data: any, fullData:any, dwEntityProps:any, dataRowCol:any, entity:string, dwFilters:any, caller?:any) => void;
    getObjectText?: (object: any) => string;
    accessors: {
        getPosition?: (entity: any) => number[];
        getFillColor?: (entity: any) => number[];
        getLineColor?: (entity: any) => number[];
        getPointRadius?: (entity: any) => number;
        getElevation?: (entity: any) => number;
        getTransformedName?: (entity: any) => string;
    };
};

export class DWEntityLayer
    extends MapLayer
    implements IDeckGlLayer, IFieldFilter, ITimeFilter {
    _config: DWQueryConfig;
    _query: DwQuery | null;
    _data: any;
    _fullData: any;
    _errorMessage: string | null;
    _field: Field | null;
    _dtStart: string | null;
    _dtEnd: string | null;
    _dwEntityProps: any;
    _histogramData: any;
    _dataRowCol: any;
    setHistogramLoaded: Function;
    dwFilters: any;
    queryGeojson: any;
    preNullTheGeojson: boolean;
    

    constructor(
        index: number,
        id: string,
        name: string,
        visible: boolean,
        config: DWQueryConfig,
        public definitions: Definition[], 
        dwEntityProps: any,
        dataRowCol: any,
        setHistogramLoaded: Function,
        dwFilters: any,
        queryGeojson: any = false,
        preNullTheGeojson: boolean = false,
    ) {
        super(id, name, visible);
        this._config = config;
        this._query = null;
        this._data = null;
        this._fullData = null;
        this._errorMessage = null;
        this._field = null;
        this._dtStart = null;
        this._dtEnd = null;
        this._dwEntityProps = dwEntityProps;
        this._dataRowCol = dataRowCol;
        this._histogramData = null;
        this.setHistogramLoaded = setHistogramLoaded;
        this.dwFilters = dwFilters;
        this.queryGeojson = queryGeojson;
        this.preNullTheGeojson = preNullTheGeojson;
    }

    private static _sharedFullData: any = null;

    public static async fetchAndStoreDataIfNeeded(query: any): Promise<void> {
        // Check if the data has already been fetched
        console.log("111524 this._sharedFullData",this._sharedFullData)
        if (this._sharedFullData === null) {
            try {
                // Fetch data only if it hasn't been fetched before
                this._sharedFullData = await fetchData("/api/geojson", query);
                console.log("Data fetched and stored statically.");
            } catch (error) {
                console.error("Error fetching data:", error);
                throw error; // Rethrow or handle as needed
            }
        }
    }

    public async load(): Promise<boolean> {
        if (this._loading) {
            return false;
        }
        this._query = this.createQuery();
        if (this._query) {
            console.log("D112123 **** this.loadData > this.dwFilters", this.dwFilters)
            console.log("A111524 A this._query", this._query, this._config);
            await this.loadData();
        }

        return this._data !== null;
    }

    public async syncWithAwaited(): Promise<boolean> {
        if (this._loading) {
            return false;
        }
        this._query = this.createQuery();
        if (this._query) {
            console.log("A111524 B this._query", this._query, this._config, this.preNullTheGeojson);
            console.log("D112123 **** this.loadData > this.dwFilters", this.dwFilters)
            if (!this.preNullTheGeojson){
                await this.loadData(null, true);
            }
        }

        return this._data !== null;
    }

    private async loadData(dwFilters?:any, syncAwaited:boolean = false) {
        this._loading = true;
        this._data = null;
        this._fullData = null;
        if (dwFilters){
            this.dwFilters = dwFilters;
        }
        try {
            console.log("111524 this._config", this._config);
            console.log("B021524 this._query", this._query);
            console.log("111524 this.preNullTheGeojson", this.preNullTheGeojson);
            console.log("A111524 syncAwaited", syncAwaited);
            console.log("XX111723 loadData()");
            this.setHistogramLoaded(false);
            this._histogramData = null;
            /*if (Object.keys(this.queryGeojson).length === 0){
                this._fullData = await fetchData("/api/geojson", this._query);
            }else{
                this._fullData = {...this.queryGeojson};
            }*/
            try {
                // Ensure data is fetched and stored if needed
                if (!syncAwaited){// && !this.preNullTheGeojson){
                    DWEntityLayer._sharedFullData = null;
                    await DWEntityLayer.fetchAndStoreDataIfNeeded(this._query);
                }
                console.log("A111524 DWEntityLayer", DWEntityLayer);
                // Now use the statically stored data
                if (this.preNullTheGeojson){
                    this._fullData = null;
                }else{
                    this._fullData = DWEntityLayer._sharedFullData;
                }
                this._data = { ...this._fullData };
                // Proceed with using this._data as before...
            } catch (e) {
                this._errorMessage = e.message;
                console.error(e.message);
            } finally {
                this._loading = false;
            }
            console.log("A111524 this._data", this._data);
            console.log("A111524 this._fullData", this._fullData);
            this._data = {...this._fullData};

            //console.log("B021524 this._config.transform", this._config.transform);
            if (this._data && this._data.features && this._config.transform) {
                console.log("createDwLayers > data retrieved", this._data);
                console.log('A021524 this._dwEntityProps', this._dwEntityProps)
                console.log('xxx this._query', this._query)
                console.log('D112123 this.dwFilters', this.dwFilters)
                let entity = this?._query?.entity ? this._query?.entity : 'plant';
                const scales = await this._config.transform(
                    this.scalarsFromConfigProperties(), 
                    this._config.colorRamp, 
                    this._data,
                    this._fullData,
                    this._dwEntityProps,
                    this._dataRowCol,
                    entity,
                    this.dwFilters,
                    "A"
                );
                this._histogramData = scales[4];
                if (this._visible){
                    console.log("this", this)
                    this.setHistogramLoaded(true);
                }
                console.log("X111723 scales", scales);
            }
        } catch (e) {
            this._errorMessage = e.message;
            console.error(e.message);
        } finally {
            this._loading = false;
        }
    }

    private scalarsFromConfigProperties(): DWPropertyScaleDesc[]{
        console.log("ZZ022823 this._config.properties", this._config.properties)
        return this._config.properties
            .filter((p: DWPropertyQueryConfig) => p.scale != undefined)
            .map((p: DWPropertyQueryConfig) => {
                return {
                    name: `${p.name}_${p.statistic}`,
                    min: p.scale?.min,
                    max: p.scale?.max
                } as DWPropertyScaleDesc
            });
    }

    public updateQueryForField(field: Field | null) {
        this._field = field;
    }

    public updatePointRadiusForField(field: Field | null) {
        if (this._config.layerOptions.pointRadiusScale){
            if (field?.plant_spacing && field.row_spacing){
                let factor = 6;
                if (this._config.title === 'Bloom Index (color, radius)'){
                    factor = 9;
                }
                let rowScale = field.row_spacing / factor
                let plantScale = field.plant_spacing / factor
                console.log("F021524 pointRadiusScale rowScale", rowScale);
                console.log("F021524 pointRadiusScale plantScale", plantScale);
                this._config.layerOptions.pointRadiusScale = (rowScale > plantScale) ? plantScale : rowScale;
            }
        }
        if(this._config.layerOptions.coverage){ 
            if (field?.plant_spacing && field.row_spacing){                   
                let rowScale = field.row_spacing / 15
                let plantScale = field.plant_spacing / 15 
                console.log("F021524 coverage rowScale", rowScale);
                console.log("F021524 coverage plantScale", plantScale);
                this._config.layerOptions.coverage = (rowScale > plantScale) ? plantScale : rowScale;
            }
        }
    }

    public updateQueryForTime(dtStart: string, dtEnd: string) {
        this._dtStart = dtStart;
        this._dtEnd = dtEnd;
    }

    public hasError(): boolean {
        return this._errorMessage !== null;
    }

    public getError(): string {
        return this._errorMessage ? this._errorMessage : "";
    }

    public getColorRamp(): string {
        return this._config.colorRamp;
    }

    public async getTransform(dwFilters?:any): Promise<any> {
        if (this._config.transform){
            let entity = this?._query?.entity ? this._query?.entity : 'plant';
            this.dwFilters = dwFilters
            console.log("D112123 dwFilters", dwFilters)
            console.log("D112123 this.dwFilters", this.dwFilters)
            return await this._config.transform(
                this.scalarsFromConfigProperties(), 
                this._config.colorRamp, 
                this._data,
                this._fullData,
                this._dwEntityProps,
                this._dataRowCol,
                entity,
                this.dwFilters,
                "B"
            );
        }else{
            return null;
        }
    }

    dataLoaded(): boolean {
        return this._data != null;
    }

    getDescForObject(object: any,  propertyUnitsData: any | null): string {

        return this._config.getObjectText ? this._config.getObjectText(object) : this.getDescForObjectDefault(object, propertyUnitsData);
    }

    private getDescForObjectDefault(object: any, propertyUnitsData: any | null) {
        let text = '';

        for(let prop of this._config.properties) {
            //console.log("B112823 prop", prop)
            //console.log("A112823 object", object)
            //console.log("A112823 this._config", this._config)
            //console.log("B112823 propertyUnitsData", propertyUnitsData)
            let unitObj = propertyUnitsData ? propertyUnitsData.syncarto_dw_property.find((u:any) => 
                        u?.name?.toLowerCase() === prop?.property?.toLowerCase() || u?.shortcode?.toLowerCase() === prop?.property?.toLowerCase()
                ) : null;
            if (["row","plant"].includes(prop?.property?.toLowerCase())){
                unitObj = null;
            }
            //console.log("B112823 unitObj", unitObj)
            let _unit = unitObj ? unitObj.unit : null;
            if (prop.property === "treatment color" || prop.property === "Cultivar"|| prop.property === "status"){
                const key = `${prop.property}_${prop.statistic}`;
                let _valueString = object.properties[key] ? object.properties[key] : "null";
                if (this._config.accessors.getTransformedName){
                    _valueString = this._config.accessors.getTransformedName(_valueString);
                }
                text += `${prop.title}: ${_valueString}` + '\n';
            }else{
                const key = `${prop.property.replace(" ", "")}_${prop.statistic}`;
                //console.log("B112823 object.properties[key]", object.properties[key])
                if (_unit && _unit.abbrv){
                    text += `${prop.title} (${_unit.abbrv}): ${object.properties[key] ? dcRound(object.properties[key]) : "null"}` + '\n';
                }else{
                    text += `${prop.title}: ${object.properties[key] ? dcRound(object.properties[key]) : "null"}` + '\n';
                }
            }
        }

        return text;
    }

    private createQuery(): DwQuery | null {
        if(!this._field) {
            return null;
        }


         // try to find the correct definition based on the crop
         
         console.log('033123 this.definitions', this.definitions);

         let defNames = this._config.definitionName;
         //if(this.definitions.length > 2) {
            if(this._field.crop?.name.toLocaleLowerCase() === 'grapes') {
                defNames = ['vine'];
            } else if(this._field.crop?.name.toLocaleLowerCase() === 'almonds') {
                defNames = ['tree'];
            }
         //}
         this._config.definitionName = defNames;
         let defName = defNames.find(name => {
             return this.definitions.find((d:Definition) => d.name.toLowerCase() == name.toLowerCase()) !== undefined;
         });
         if(!defName) { // To solve for scenario caused by the above hack (above) to draw defNames from 'grapes' or 'almond' crop.name values. If switching from an org with different entity type (e.g., Windfall / 'vine', the definition needs to be switched back to plant.)
            let reinstatePlant = this.definitions.find((d:Definition) => d.name.toLowerCase() == 'plant');
            if (reinstatePlant && reinstatePlant.name){ defName = reinstatePlant.name }
         }
         if(!defName) {
             return null;
         }
         const definition = this.definitions.find((d:Definition) => d.name.toLowerCase() == defName?.toLowerCase()) as Definition;
         //console.log("definitionx110922 (at C)", definition);
         if(!definition) {
             console.error('definition not found in org (at C)', defName, this.definitions);
             return null;
         }
        const { id, name, feature } = definition;
        let query = new DwQuery(id!, name, feature);
        // dimensions
        query.addDimension({
            type: "entity",
            id: `${name}:${name}`,
            name: name,
            bin: null,
        });

        // measures
        for (let config of this._config.properties) {
            //console.log("022324 definition", definition);
            //console.log("022324 config", config);
            const property = this.getProperty(
                definition,
                config.property
            );
            if (!property) {
                continue;
            }
            //if ((config.name !== "CanopyVolume") && (config.name !== "treatment color") && (config.name !== "status") && (config.name !== "Cultivar")){
            if (config.geojson){
                if (property.type === "stats") {
                    if (config.name === "CanopyVolume"){
                        /*query.addMeasure({
                            type: "property",
                            id: `${name}:${property.id}`,
                            name: config.name,
                        });*/
                    }else{
                        query.addMeasure({
                            type: "property",
                            id: `${name}:${property.id}`,
                            name: config.name,
                            stat: config.statistic,
                            aggregation: config.summerize,
                        });
                    }
                } else {
                    if ((config.name !== "status") && (config.name !== "Cultivar")){
                        query.addMeasure({
                            type: "property",
                            id: `${name}:${property.id}`,
                            name: config.name,
                            bin: "value",
                        });
                    }
                }
            }
        }

        // filters
        if (this._field && this._field.entityId) {
            const fieldEntity = definition.entity.find((e) => e.relationship_type === 'field');

            if(fieldEntity) {
                query.addFilter({
                    type: "entity",
                    id: `${name}:${fieldEntity.name}`,
                    name: "field",
                    operation: "eq",
                    value: this._field.entityId?.toString(),
                });
            }
        }
        //console.log("E022823 this._field",this._field);
        //console.log("E022823 this._dtStart",this._dtStart);
        //console.log("E022823 this._dtEnd",this._dtEnd);
        if (this._field && this._dtStart && this._dtEnd) {
            const propertyConfig = this._config.properties[0];
            console.log("propertyConfig", propertyConfig);
            console.log("definition", definition);
            const property = this.getProperty(
                definition,
                propertyConfig.property
            );
            //console.log("E022823 property.type",property?.type);
            // stats is the only property that has a time components
            if (property && property.type === "stats") {
                query.addFilter({
                    type: "property",
                    id: `${name}:${property.id}[time]`,
                    name: propertyConfig.name,
                    operation: "between",
                    value: [this._dtStart, this._dtEnd],
                });
            }
        }

        return query;
    }

    private getProperty(
        definition: Definition,
        propName: string
    ): Property | null {
        const property = definition.property.find(
            (p: Property) => p.property.toLowerCase() === propName.toLowerCase()
        );

        return property ?? null;
    }

    public getDeckGlLayer(zoom: number, selected?:number, setSelected?:Function, entity?:string) {
        if (!this._data) {
            return null;
        }

        if (!this._data.features) {
            return null;
        }
        //console.log("112123 this._data", this._data);
        //console.log("112123 this", this);
        //console.log("112123 this._config", this._config);
        // https://codesandbox.io/s/pensive-rain-k2izfy?file=/src/components/BackdropMap/BackdropMap.tsx
        const config = {
            id: this.id + (this.dwFilters.version ? this.dwFilters.version : ""),
            entity: entity ? entity : 'plant',
            visible: this._visible,
            //data: this._config.layerType === "geojson" ? this._data : this._data.features,
            ...this._config.accessors,
            ...this._config.layerOptions,
            lineWidthScale: 1,
            lineWidthMinPixels: 0,
            lineWidthMaxPixels: 3,
            stroked: true,
            getLineColor: [255, 255, 255, 255],
            getLineWidth: (g: any) => (g.properties[`${entity ? entity : 'plant'}_id`] === selected ? 2 : 0),
            onClick: (info: any) => {
                if (setSelected){
                    setSelected(info.object.properties[`${entity ? entity : 'plant'}_id`])
                }
              }
        };
        //console.log("A112123 config", config);
        return this._config.layerType === "geojson"
            ? new GeoJsonLayer({
                ...config,
                data:this._data,
                updateTriggers: {
                    getLineWidth: [selected],
                },
            })
            : new ColumnLayer({ // https://deck.gl/docs/api-reference/layers/column-layer
                ...config,
                data:this._data.features,
                getFillColor: (d:any) => (d.properties[`${entity ? entity : 'plant'}_id`] === selected ? [255,255,255,255] : d.properties.vvi_color),
                updateTriggers: {
                    getFillColor: [selected],
                },
            });
    }
}
